import { getPreferredPhone, useGetAllContacts } from "@api/contactService";
import { useEffect, useState } from "react";
import Box from '@mui/joy/Box';
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';
import ObjectIndex from "@components/objects/ObjectIndex";
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { useGetAllUsers } from "@api/userService";
import { Alert, Autocomplete, AutocompleteOption, Button, Checkbox, Grid, ListItemContent, ListItemDecorator, Stack } from "@mui/joy";
import { Link } from "react-router-dom";
import { ContextualHelp } from "@components/ContextualHelp";
import { countries, userRoles } from "@utils/selectOptions";
import Subheader from "@components/layout/Subheader";
import { FormProvider, useForm } from "react-hook-form";
import { ObjectPrimaryInfoEdit } from "@components/objects/ObjectPrimaryInfoEdit";
import ObjectColumn from "@components/objects/ObjectColumn";
import { useTenant } from "@providers/TenantProvider";
import { authenticatedApi } from "api";
import toast from "react-hot-toast";
import { useGetAllCoordinatingPrograms } from "@api/coordinatingProgramService";
import MaestroLoader from "@components/MaestroLoader";
import { formatDateForDatabase } from "@utils/dates";
import { useDocumentTitle } from "@uidotdev/usehooks";
import { events } from "@utils/analytics";

const volunteerHourFields = [
    {
        name: 'contacts',
        label: 'Contacts',
        type: 'relationship',
        endpoint: 'contacts',
        multiple: true,
        placeholder: 'Choose...',
        showRequired: (object) => true,
        config: {
            validate: (value, object) => {
                if (!value || !value.length) return 'Required';
                return true;
            },
            // required: true,
        },
    },
    {
        name: 'hours',
        label: 'Hours Volunteered',
        type: 'number',
        placeholder: 'e.g. 0.5 or 6',
        config: {
            required: true,
        },
    },
    {
        name: 'volunteered_at',
        label: 'Date Volunteered',
        type: 'date',
        placeholder: 'e.g. 05/23/2016',
        config: {
            required: true,
        },
    },
    // todo: carry over involvement picker from table edit
    {
        name: 'involvement_id',
        label: 'Related Involvement',
        type: 'relationship',
        endpoint: 'involvements',
        groupBy: (option) => option.category_name,
    },
    {
        name: 'notes',
        label: 'Notes',
        type: 'text',
        placeholder: 'e.g. Board Meeting',
    },
    {
        type: 'submit',
        label: false,
        buttonLabel: 'Add Time',
    },
];

export default function VolunteerHoursBulkAdd() {
    useDocumentTitle(`Add Volunteer Hours | Maestro Community Manager`);

    const formMethods = useForm({
        defaultValues: {
            //
        },
    });
    const {
        setValue,
        reset,
        handleSubmit,
        formState: { isSubmitting, errors }
    } = formMethods;

    const onSubmit = (fields) => {
        let hoursToAdd = [];

        for(const contact of fields.contacts) {
            hoursToAdd.push({
                contact_id: contact.id,
                is_staff: contact.is_staff,
                time_taken: Math.max(fields.hours, 1), // ensure there's no negative numbers
                volunteered_at: fields.volunteered_at,//formatDateForDatabase $scope.data.volunteered_at.format('YYYY-MM-DD'),
                involvement_id: fields.involvement_id,// $scope.data.involvement_id,
                notes: fields.notes,//$scope.data.notes
            });
        }

        const performUpdate = authenticatedApi.post(`/volunteer-hours`, hoursToAdd);
        toast.promise(performUpdate, {
            loading: `Adding...`,
            success: `The time was added!`,
            error: (err) => /*err?.response?.data?.message?.includes('Duplicate entry') ? 'This email address is already in use.' :*/ `There was an error while saving.`,
        });
        performUpdate.then(() => {
            events.volunteerHoursBulkAdded();

            // note: this is a hack to workaround chrome not properly resetting state
            reset({volunteered_at: ""});
            setTimeout(() => {
                reset();
            }, 10);
        });

    };
    const orgInfo = {};

    return (<>
        <Subheader
            title={'Add Volunteer Hours'}
            tint={'default'}
        >
        </Subheader>

        <Box sx={theme => ({
            // backgroundImage: `linear-gradient(180deg, ${theme.palette['default'][100]} 0%, white 100%);`,// : null,
            backgroundAttachment: 'fixed',
            minHeight: 'calc(100% - var(--Header-height))',
            p: 2,
        })}>
            <form
                onSubmit={handleSubmit(onSubmit)}
                onKeyDown={(e) => {
                    if (e.key !== 'Enter') return;
                    const t = e.target;
                    // Submit would steal enter input once form had valid input
                    if (t.tagName === 'BUTTON' || t.tagName === 'TEXTAREA') return;
                    e.preventDefault();
                }}
                initialData={orgInfo}
                >
                <FormProvider {...formMethods}>
                    <Grid container columns={12} gap={2}>
                        <ObjectColumn>
                            <ObjectPrimaryInfoEdit
                                title={<>&nbsp;</>}
                                tint={'default'}
                                fields={volunteerHourFields}
                            />
                        </ObjectColumn>
                        <ObjectColumn>
                        </ObjectColumn>
                    </Grid>
                </FormProvider>
            </form>
        </Box>
    </>);
}
